import { Diagnostic } from "@siteimprove/alfa-act";
/**
 * @public
 */
export class WithOtherHeading extends Diagnostic {
    static of(message, otherHeading, currentLevel, otherLevel, otherPosition) {
        return otherHeading === undefined ||
            currentLevel === undefined ||
            otherLevel === undefined ||
            otherPosition === undefined
            ? Diagnostic.of(message)
            : new WithOtherHeading(message, otherHeading, currentLevel, otherLevel, otherPosition);
    }
    _otherHeading;
    _currentLevel;
    _otherLevel;
    _otherPosition;
    constructor(message, otherHeading, currentLevel, otherLevel, otherPosition) {
        super(message);
        this._otherHeading = otherHeading;
        this._currentLevel = currentLevel;
        this._otherLevel = otherLevel;
        this._otherPosition = otherPosition;
    }
    get otherHeading() {
        return this._otherHeading;
    }
    get currentHeadingLevel() {
        return this._currentLevel;
    }
    get otherHeadingLevel() {
        return this._otherLevel;
    }
    get otherPosition() {
        return this._otherPosition;
    }
    equals(value) {
        return (value instanceof WithOtherHeading &&
            value._message === this._message &&
            value._otherHeading.equals(this._otherHeading) &&
            value._currentLevel === this._currentLevel &&
            value._otherLevel === this._otherLevel &&
            value._otherPosition === this._otherPosition);
    }
    hash(hash) {
        super.hash(hash);
        hash.writeNumber(this._currentLevel);
        hash.writeNumber(this._otherLevel);
        hash.writeString(this._otherPosition);
        this._otherHeading.hash(hash);
    }
    toJSON(options) {
        return {
            ...super.toJSON(options),
            otherHeading: this._otherHeading.toJSON(options),
            currentHeadingLevel: this._currentLevel,
            otherHeadingLevel: this._otherLevel,
            otherPosition: this._otherPosition,
        };
    }
}
/**
 * @public
 */
(function (WithOtherHeading) {
    /**@public */
    function isWithOtherHeading(value) {
        return value instanceof WithOtherHeading;
    }
    WithOtherHeading.isWithOtherHeading = isWithOtherHeading;
})(WithOtherHeading || (WithOtherHeading = {}));
//# sourceMappingURL=with-other-heading.js.map